export const Context = {
    VNext: 'VNext',
};
export default Context;
